<template>
  <div class="bodyback-light pages">
    <notifications></notifications>
    <Navbar></Navbar>

    <div class="container pb-0 pt-md-5 pt-sm-5 pt-5">
      <div class="row justify-content-center">
        <div class="col-xl-4 col-lg-7 forms card-alerts">
          <form action="">
            <div class="text-center custom-col mt-4">
              <h1 class="title-view-2 mb-1">Hello</h1>
              <div class="textInHorizontalLine">
                <span>{{ supplierName }}</span>
              </div>
            </div>

            <div class="card pb-3 mt-4 mb-2">
              <div class="col-12 text-center">
                <i
                  class="f-30"
                  v-bind:class="[
                    { 'text-success flaticon-check-3': isConfirmed },
                    { 'text-danger flaticon-error': isAnError }
                  ]"
                ></i>

                <p class="p-content-card text-center">
                  The quote
                  <span class="strong-lg d-block "> {{ quoteNumber }}</span>

                  <span v-if="isConfirmed"
                    >has been <strong>Confirmed.</strong>
                  </span>

                  <span v-if="isAnError"
                    >couldn't be confirmed. An error occurred while confirming
                    this reservation. Please try again.</span
                  >
                </p>

                <hr />
                <span class="info-card text-center">
                  For assistance please contact us
                  <a href="mailto:info@rhomtrip.com">info@rhomtrip.com</a>
                </span>
              </div>

              <div class="loading mt-3" v-if="loader">
                <div class="dot"></div>
                <div class="dot"></div>
                <div class="dot"></div>
                <div class="dot"></div>
                <div class="dot"></div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <Footer class="footer-pages"></Footer>
  </div>
</template>
<script>
import Navbar from "../../Layout/Navbarpages.vue";
import Footer from "../../Layout/ContentFooter.vue";
import endpoint from "../../Commons/Services";

export default {
  components: {
    Navbar: Navbar,
    Footer: Footer
  },
  data() {
    return {
      loader: false,
      isAnError: false,
      isConfirmed: false,
      quoteId: null,
      supplierName: "",
      quoteNumber: "",
      token: ""
    };
  },
  async created() {
    this.quoteId = this.$route.params.id;
    this.supplierName = this.$route.query.supplierName
      ? this.$route.query.supplierName
      : "";
    this.quoteNumber = this.$route.query.quoteNumber
      ? this.$route.query.quoteNumber
      : "";
    this.token = this.$route.query.token ? this.$route.query.token : "";

    await this.acceptQuote(this.quoteId);
  },
  methods: {
    /** Accept Quote
     * @param {string} quoteId - The ID of the quote to accept
     */
    async acceptQuote(quoteId) {
      try {
        this.loader = true;
        const { data } = await endpoint.quotes.services.acceptQuote(
          quoteId,
          this.token
        );
        this.loader = false;
        if (data) {
          this.isConfirmed = true;
        } else {
          this.isAnError = true;
        }
      } catch (error) {
        this.isAnError = true;
        this.loader = false;
      }
    }
  }
};
</script>
